export enum CoreUxOrderStatus {
  Skipped = 'skipped',
  Confirmed = 'confirmed',
  ConfirmedPending = 'confirmed-pending',
  ToBeCompleted = 'to-be-completed',
  WithoutMenu = 'without-menu',
  Shipped = 'shipped'
}
